import { Box, Button, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PageBackground = styled(Box)(({ theme }) => ({
	minHeight: '100vh',
	width: '100%',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	backgroundColor: theme.palette.grey[100],
}));

export const LoginCard = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: theme.spacing(2),
	padding: theme.spacing(5),
	backgroundColor: theme.palette.background.paper,
	borderRadius: Number(theme.shape.borderRadius || 1) * 2,
	boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
	width: '100%',
	maxWidth: 400,
	textAlign: 'center',
}));

export const LogoContainer = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: theme.spacing(2),
	width: '100%',
}));

export const WelcomeSection = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: theme.spacing(0.5),
	width: '100%',
}));

export const GoogleButton = styled(Button)(({ theme }) => ({
	width: '100%',
	padding: theme.spacing(1.5),
	borderRadius: theme.shape.borderRadius,
	textTransform: 'none',
	fontSize: '1rem',
	fontWeight: 500,
	gap: theme.spacing(1),
}));

export const DebugSection = styled(Box)(({ theme }) => ({
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	gap: theme.spacing(1),
}));

export const DebugGrid = styled(Box)(({ theme }) => ({
	display: 'grid',
	gridTemplateColumns: '1fr 1fr',
	gap: theme.spacing(1),
}));

export const DebugButton = styled(Button)(({ theme }) => ({
	textTransform: 'none',
	fontSize: '0.8rem',
	padding: theme.spacing(0.75, 1),
	borderRadius: theme.shape.borderRadius,
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
	width: '100%',
	color: theme.palette.text.disabled,
	fontSize: '0.75rem',
}));
